import React, { useContext } from 'react';
import { ApplicationUIContext, Form, SectionTitle, InputNumber } from '@yuhuinc/ui-library';
import { Select } from 'antd';
import { ContentWrapper, StyledSpace } from '../common/StyledComponents';
import { getTranslatedString } from 'helpers/i18n';
import { requiredRule } from '../common/Rules';

const options = [
  { value: 'weekly', label: getTranslatedString('landlordPortal.incentives.weekly') },
  { value: 'monthly', label: getTranslatedString('landlordPortal.incentives.monthly') },
];

const MIN_INVENTORY_NUMBER = 0;
const MAX_INVENTORY_NUMBER = 99999;

const Inventory = () => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <ContentWrapper>
      <SectionTitle>{getTranslatedString('landlordPortal.incentives.inventory')}</SectionTitle>

      <StyledSpace direction={isMobile ? 'vertical' : 'horizontal'}>
        <Form.Item
          name="inventory"
          label={getTranslatedString('landlordPortal.incentives.inventory')}
          rules={[requiredRule]}
        >
          <InputNumber min={MIN_INVENTORY_NUMBER} max={MAX_INVENTORY_NUMBER} />
        </Form.Item>

        <Form.Item
          name="inventory_reset_frequency"
          label={getTranslatedString('landlordPortal.incentives.inventoryReset')}
          rules={[requiredRule]}
        >
          <Select options={options} />
        </Form.Item>
      </StyledSpace>
    </ContentWrapper>
  );
};

export default Inventory;
